import { useState, useEffect } from 'react';
import useClientHydrated from '@charlietango/use-client-hydrated';
import json2mq from 'json2mq';

function getMediaQuery(query) {
  return window.matchMedia(typeof query === 'string' ? query : json2mq(query));
}

function useMedia(query, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var clientHydrated = useClientHydrated();

  var _useState = useState(function () {
    var initialQuery = clientHydrated ? getMediaQuery(query) : undefined;
    return initialQuery ? initialQuery.matches : defaultMatches;
  }),
      matches = _useState[0],
      setMatches = _useState[1];

  useEffect(function () {
    var mediaQuery = getMediaQuery(query);
    if (!mediaQuery) return undefined;
    setMatches(mediaQuery.matches);

    var listener = function listener() {
      return setMatches(mediaQuery.matches);
    };

    mediaQuery.addListener(listener);
    return function () {
      mediaQuery.removeListener(listener);
    };
  }, [query]);
  return matches;
}

export default useMedia;
